import React from 'react';
import { StyleProps } from '@summer/react-kit';
import { OptionFilter } from 'src/app/common/models/filter';
import { ConnectedCommonOptionFilter } from 'src/app/search/components/SearchPanel/CommonOptionFilter';

export const SearchDrivePerformanceFilter = (props: StyleProps) => (
  <ConnectedCommonOptionFilter
    columns={{ desktop: 2, mobile: 3 }}
    kind={OptionFilter.Drive}
    {...props}
  />
);
